import { makeStyles } from '@material-ui/core';

export const resumeTransactionStyles = makeStyles({
  message: {
    width: '50%',
    textAlign: 'center',
    paddingBottom: 20,
  },
  listButton: {
    maxWidth: '16vw',
    marginLeft: '0.5vw',
    fontSize: '2.08vh',
    lineHeight: 1.1,
    textTransform: 'uppercase',
  },
});
